import i18next from 'i18next';

export const translateUpsertErrorMessage = (errorMessage: string | undefined) => {
  if (errorMessage?.toLowerCase().startsWith('cannot mark credit analysis as complete')) {
    return i18next.t('fieldsRequiredForInnovationError');
  }
  return errorMessage;
};
